import React, { useEffect, useRef, useState } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = { width: "100%", height: "500px" };
const PropertyMap = ({ properties }) => {
  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDQJsMZLZqlWRUAmS_4zNPhawYKFsB55AU",
  });

  // กำหนด center จาก property แรก
  const centerCoords =
    properties.length && properties[0].latitude && properties[0].longitude
      ? {
          lat: parseFloat(properties[0].latitude),
          lng: parseFloat(properties[0].longitude),
        }
      : { lat: 7.8804, lng: 98.3923 }; // default

  useEffect(() => {
    if (isLoaded && mapRef.current && !mapLoaded && properties.length > 0) {
      const map = mapRef.current;

      properties.forEach((prop) => {
        if (prop.latitude && prop.longitude) {
          const coords = {
            lat: parseFloat(prop.latitude),
            lng: parseFloat(prop.longitude),
          };

          new window.google.maps.Marker({ position: coords, map });

          new window.google.maps.Circle({
            strokeColor: "#007bff",
            strokeOpacity: 0.6,
            strokeWeight: 2,
            fillColor: "#007bff",
            fillOpacity: 0.15,
            map,
            center: coords,
            radius: 1500, // 1.5 km
          });
        }
      },[centerCoords]); 

      // Center map ที่ property แรก
      map.setCenter(centerCoords);
      map.setZoom(14);

      setMapLoaded(true);
    }
  }, [isLoaded, mapLoaded, properties]);

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={centerCoords} // ใช้ centerCoords ของ property แรก
      zoom={14}
      onLoad={(map) => (mapRef.current = map)}
    />
  );
};

export default PropertyMap;
